import styled from 'styled-components'

import { Button } from 'components'

export const SideBarCorner = styled.div`
  align-self: center;
  margin-left: -9.35rem;
  margin-top: -15rem;
  .chevron {
    color: white;
    display: block;
    font-size: 4.8rem;
    margin-left: 9rem;
    margin-top: -16rem;
    transform: translateY(-110%);
  }
`

export const Logo = styled.img.attrs({
  alt: 'Lupa com uma folha com Ecotrace escrito ao lado',
  src: '/images/logo.png'
})`
  height: auto;
  object-fit: contain;
  object-position: center;
  margin: 0 0 3rem 0;
  width: 17rem;
`

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  padding: 0 2rem;
`

export const Title = styled.h1`
  color: ${({ theme }) => theme.colors.primary};
  font-size: 3rem;
  font-weight: 600;
  line-height: 3.6rem;
  margin-bottom: 2rem;
  text-align: center;
`

export const Description = styled.p`
  color: ${({ theme }) => theme.colors.darkGray};
  font-size: 1.6rem;
  font-weight: 400;
  line-height: 2.4rem;
  margin-bottom: 4rem;
  max-width: 48rem;
  text-align: center;
`

export const RequestButton = styled(Button)`
  margin-top: 1rem;
`
